import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { addMessage, AddMessageApiParameter } from "@insite/client-framework/Services/MessageService";
import loadQuote from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuote";
import {
    chain,
    DispatchLoadQuote,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/SendMessage";
import { MessageModel, QuoteModel } from "@insite/client-framework/Types/ApiModels";
import loadDiscrepancyMessages from "@tKgpco/Store/Data/DiscrepancyHistory/Handlers/LoadDiscrepancyMessages";
import loadOrderDetailsMessages from "@tKgpco/Store/Data/OrderHistoryDetail/Handlers/LoadOrderMessages";
import loadRMAMessages from "@tKgpco/Store/Data/RMA/Handlers/LoadRMAMessages";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        quote: QuoteModel;
        message: string;
        onError?: (error: string) => void;
    } & HasOnSuccess,
    AddMessageApiParameter,
    MessageModel
>;

export const PopulateApiParameterCustom: HandlerType = props => {
    const isOrderDetailsMessage = props.parameter.quote.properties?.type === "Order";
    const isDiscrepancyMessage = props.parameter.quote.properties?.type === "Discrepancy";
    const isRMAMessage = props.parameter.quote.properties?.type === "RMAHistory";

    props.apiParameter = {
        ...(!isOrderDetailsMessage &&
            !isDiscrepancyMessage &&
            !isRMAMessage && {
                customerOrderId: props.parameter.quote.id,
            }),
        message: props.parameter.message,
        toUserProfileName: props.parameter.quote.initiatedByUserName,
        subject: isOrderDetailsMessage
            ? `OrderHistory ${props.parameter.quote.orderNumber} Communication`
            : isDiscrepancyMessage
              ? `Discrepancy ${props.parameter.quote.orderNumber} Communication`
              : isRMAMessage
                ? `RMA ${props.parameter.quote.orderNumber} Communication`
                : `Quote ${props.parameter.quote.orderNumber} communication`,
        process: isOrderDetailsMessage
            ? `OrderHistory-${props.parameter.quote.id}`
            : isDiscrepancyMessage
              ? `DiscHistory-${props.parameter.quote.id}`
              : isRMAMessage
                ? `RMAHistory-${props.parameter.quote.id}`
                : "RFQ",
    };
};

export const DispatchLoadQuoteCustom: HandlerType = props => {
    const isOrderDetailsMessage = props.parameter.quote.properties?.type === "Order";
    const isDiscrepancyMessage = props.parameter.quote.properties?.type === "Discrepancy";
    const isRMAMessage = props.parameter.quote.properties?.type === "RMAHistory";

    if (isOrderDetailsMessage) {
        props.dispatch(loadOrderDetailsMessages({ orderHistoryId: props.parameter.quote.id, size: 4 }));
    }
    if (isDiscrepancyMessage) {
        props.dispatch(loadDiscrepancyMessages({ Id: props.parameter.quote.id, type: "DiscHistory", size: 4 }));
    }
    if (isRMAMessage) {
        props.dispatch(loadRMAMessages({ Id: props.parameter.quote.id, type: "RMAHistory", size: 4 }));
    }

    if (!isOrderDetailsMessage && !isDiscrepancyMessage && !isRMAMessage) {
        props.dispatch(loadQuote({ quoteId: props.parameter.quote.id }));
    }
};

addToChainAfter(chain, PopulateApiParameter, PopulateApiParameterCustom);
replaceInChain(chain, DispatchLoadQuote, DispatchLoadQuoteCustom);
